module.exports = __webpack_public_path__ + "media/components/loader-ef55cfb7f79e65e7d677846d7004beed.svg";